import "./App.css";
import { lazy, Suspense } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router";
import { useKeyboardShortcut } from "./hooks/useKeyboardShortcut";
import AuthLayout from "./components/layouts/Auth/AuthLayout";
import DashboardLayout from "./components/layouts/Dashboard/DashboardLayout";
import { ERoutes } from "./components/layouts/Dashboard/dashboardLayout.interface";
import Products from "./features/products";
import ColdBoot from "./components/ColdBoot/ColdBoot";
const Login = lazy(() =>
  import("./features/auth").then((module) => ({ default: module.Login }))
);
const Register = lazy(() =>
  import("./features/auth").then((module) => ({ default: module.Register }))
);
const ForgotPassword = lazy(() =>
  import("./features/auth").then((module) => ({
    default: module.ForgotPassword,
  }))
);
const ResetPassword = lazy(() =>
  import("./features/auth").then((module) => ({
    default: module.ResetPassword,
  }))
);
const Activity = lazy(() => import("./features/activity"));
const Distributors = lazy(() => import("./features/distributors"));
const Purchase = lazy(() => import("./features/purchase"));
const NotFound = lazy(() => import("./components/NotFound/NotFound"));
const AddPurchase = lazy(
  () => import("./features/purchase/components/AddPurchase")
);
const CustomOrder = lazy(() => import("./features/customerOrder"));
const Analytics = lazy(() => import("./features/analytics"));
const Retail = lazy(() => import("./features/retail"));
const Wholesale = lazy(() => import("./features/wholesale"));
const AddWholesale = lazy(
  () => import("./features/wholesale/components/AddWholesale")
);
const Inventory = lazy(() => import("./features/inventory"));
const WholesaleInvoice = lazy(
  () => import("./features/wholesale/components/WholesaleInvoice")
);

function App() {
  useKeyboardShortcut();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />

        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

        <Route element={<DashboardLayout />}>
          <Route path={ERoutes.Activity} element={<Activity />} />
          <Route path={ERoutes.Analytics} element={<Analytics />} />
          <Route path={ERoutes.Retail} element={<Retail />} />
          <Route path={ERoutes.Wholesale} element={<Outlet />}>
            <Route index element={<Wholesale />} />
            <Route path="add" element={<AddWholesale />} />
            <Route path=":id" element={<Outlet />}>
              <Route index element={<WholesaleInvoice />} />
              <Route path="edit" element={<AddWholesale />} />
            </Route>
          </Route>
          <Route path={ERoutes.Products} element={<Products />} />
          <Route path={ERoutes.Distributors} element={<Distributors />} />
          <Route path={ERoutes.Purchase} element={<Outlet />}>
            <Route index element={<Purchase />} />
            <Route path="add" element={<AddPurchase />} />
          </Route>
          <Route path={ERoutes.Inventory} element={<Inventory />} />
          <Route path={ERoutes.CustomOrder} element={<Outlet />}>
            <Route index element={<CustomOrder />} />
            <Route path=":id" element={<CustomOrder />} />
          </Route>
        </Route>

        <Route path={"/cold-boot"} element={<ColdBoot />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

export default App;
